import React from 'react';
//import {auth} from '../../Firebase/Utility'
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import AppMenu from './Menu'
//import {useHistory} from 'react-router-dom'
import {createStructuredSelector} from 'reselect'
//import {selectCurrentUser} from '../../Redux/User/user.Selector'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

function MyAppBar({isLoggedIn, logout}) {
  const classes = useStyles();
  
// const history = useHistory()
  const login = ()=>{
     // history.push('/election')
  }



  return (
    <div className={classes.root}>
      <AppBar color='default'position="static">
        <Toolbar>
          <AppMenu isLoggedIn={isLoggedIn} logout={ logout}/>
          <Typography variant="h6" className={classes.title}>
            Home
          </Typography>
          {isLoggedIn?
          <Button onClick={logout}  color='inherit'>Logout</Button>
          : <Button onClick={login} href="/login"  color='inherit'>Login</Button>
          }
          
        </Toolbar>
      </AppBar>
    </div>
  );
}





  export default MyAppBar